module.exports = __webpack_public_path__ + "img/pain-spot-9.2cfe1364.svg";